import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetSearchingResultsActionType {
  Reset = 'searchingResults/resetSearchingResults',
}

export type TResetSearchingResults = ITypedReduxAction<EResetSearchingResultsActionType.Reset>;
